import React, { useRef } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";
import {
  BoxContent,
  WrapperChart,
  ContainerChart,
} from "screens/bodyTemperature/BodyTemperature.style";

const CustomizedXAxisTick = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={-23} y={0} dy={8} fill="#3B3B3B">
        {payload.value}
      </text>
    </g>
  );
};

const CustomizedYAxisTick = (props: any) => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={3} fill="#3B3B3B" textAnchor="end">
        {payload.value} {payload.value === 100 && "%"}
      </text>
    </g>
  );
};

const LineChartCustom = ({ data, checkData }: any) => {
  return (
    <ContainerChart>
      <ResponsiveContainer width="100%" height={233}>
        <LineChart
          margin={{
            top: 10,
            right: 20,
            left: 0,
            bottom: 0,
          }}
          data={data}
        >
          <CartesianGrid vertical={false} strokeDasharray="5 2" />
          <XAxis
            dy={4}
            tickLine={false}
            dataKey="date"
            minTickGap={-100}
            tick={<CustomizedXAxisTick />}
            stroke="#CCCCCC"
          />
          <YAxis
            type="number"
            tickLine={false}
            interval={0}
            width={55}
            tick={<CustomizedYAxisTick />}
            stroke="#CCCCCC"
            domain={[0, 100]}
            minTickGap={25}
            axisLine={false}
          />
          {checkData.length &&
            checkData.map((item: any, index: number) => {
              return (
                item.checked && (
                  <Line
                    dataKey={index}
                    stroke={item.fill}
                    isAnimationActive={true}
                    strokeWidth={2}
                    dot={{
                      stroke: item.fill,
                      strokeWidth: 1,
                      r: 4,
                      fill: item.fill,
                      strokeDasharray: "",
                    }}
                  />
                )
              );
            })}
        </LineChart>
      </ResponsiveContainer>
    </ContainerChart>
  );
};

const ChangesLineChart = ({ data, checkData }: any) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "stress-check",
  });

  const imgRef = useRef<any>();

  return (
    <>
      {data && data.length ? (
        <BoxContent>
          <WrapperChart>
            <LineChartCustom data={data} checkData={checkData} />
          </WrapperChart>
        </BoxContent>
      ) : (
        t("no-data")
      )}
    </>
  );
};

export default ChangesLineChart;
